import axios from 'axios';
import { API_DOMAIN } from './ApiUtil';

const joinUrl = (domain: string | undefined, path: string): string => {
  if (!domain) {
    return path.startsWith('/') ? path : `/${path}`;
  }
  const normalizedDomain = domain.replace(/\/+$/, '');
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${normalizedDomain}${normalizedPath}`;
};

/** TIANAI 接口使用原生 `{code, data}`，不包 Request；与业务接口同域。 */
export const postTianai = async <T>(
  path: string,
  body: unknown = {},
): Promise<T | null> => {
  try {
    const response = await axios.post<{ code: number; data: T }>(
      joinUrl(API_DOMAIN, path),
      body,
      { headers: { 'Content-Type': 'application/json; charset=utf-8' } },
    );
    if (response.data?.code !== 200) {
      return null;
    }
    return response.data.data ?? null;
  } catch {
    return null;
  }
};
